import {NgModule} from "@angular/core";
import {InputModeDirective} from "./input.mode.directive";

@NgModule({
	declarations: [InputModeDirective],
	exports: [InputModeDirective],
})
export class InputModeModule{
}
